import { ButtonTabs } from "@/Components/ButtonTabs"
import { useEffect } from "react"
import { useIntl } from "react-intl"
import { useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom"

const REGISTER_TYPES = ["personal", "corporate"]

export const TypeSelect = ({ darkMode }: { darkMode?: boolean }) => {
  const { search } = useLocation()
  const { type } = useParams<{ type?: string }>()
  const { url } = useRouteMatch()
  const history = useHistory()
  const intl = useIntl()
  const path = url.replace(type, "").replace(/\/$/, "")
  useEffect(() => {
    if (!REGISTER_TYPES.includes(type) || type == null)
      history.push(`${path}/personal${search ?? ""}`)
  }, [type, history, path, search])
  return (
    <ButtonTabs
      mode={darkMode ? "dark" : "light"}
      value={type}
      items={REGISTER_TYPES.map((type) => ({
        label: intl.formatMessage({ id: type }),
        value: type,
      }))}
      onChange={(option) => history.push(`${path}/${option.value}${search ?? ""}`)}
    />
  )
}
